$(document).ready(function($){
    $('.sidenav').sidenav({
        edge: 'right',
        closeOnClick: true,
        draggable: true
    });

    $('.sidenav-close').on('click', function () {
        $('.sidenav').sidenav('close');
    });

    $('.sidenav').on('click', 'li a', () => {
        $('.sidenav').sidenav('close');
    });
    

});